import React from "react";
import { Form, Input } from "antd";
import { get } from 'lodash';

const TextInput = ({
  values,
  errors,
  handleSubmit,
  setFieldValue,
  setFieldTouched,
  name,
  label,
  formItemLayout,
  placeholder,
  readOnly,
  rows,
  nolabel,
  colon
}) => (
  <Form.Item label={nolabel ? null :label} {...formItemLayout}
    hasFeedback={!!get(errors,name)}
    validateStatus={get(errors,name) && "error"}
    help={get(errors,name)}
    colon={colon}
  >
    <Input.TextArea
      placeholder={placeholder}
      value={get(values,name)}
      onChange={event => setFieldValue(name, event.target.value)}
      onBlur={() => setFieldTouched(name)}
      onPressEnter={null}
      readOnly={readOnly}
      rows={rows}
    />
  </Form.Item>
);

export default TextInput;
